import React from 'react'
import styles from './BidDetailsCard.module.scss'
import ButtonCustom from '../button/ButtonCustom'
import { Typography } from '@mui/material'
import { formatCommonAmount } from '../../../util/formatAmount'

export default function BidDetailsCard({ data }) {
	return (
		<div className={styles.BidDetailsCard}>
			<div className={styles.BidDetailsCardHead}>
				<h2>Bid Details</h2>
				{/*IMPLEMENT LATER*/}
				{/* {icon && <img src="/images/edit-icon.svg" alt="edit-icon" />} */}
			</div>
			<div className={styles.BidDetailsCardBody}>
				<p className={styles.BidDetailsSemiTitle}>Bid Amount</p>
				<p>{formatCommonAmount(data?.bidAmount ?? data?.userBudget ?? 0)}</p>
			</div>
			<div className={styles.BidDetailsCardBody}>
				<p className={styles.BidDetailsSemiTitle}>Line Items Amount</p>
				<p>{formatCommonAmount(data?.rawTotal)}</p>
			</div>
			<div className={styles.BidDetailsCardBody}>
				<p className={styles.BidDetailsSemiTitle}>Notes</p>
				<p>{data?.note || '--'}</p>
			</div>
			<div className={styles.BidDetailsCardBody}>
				<p className={styles.BidDetailsSemiTitle}>Attachment</p>
				<ButtonCustom
					variant="outlined"
					size="lg"
					className={styles.fileUploadedList}
					onClick={() => {
						if(data?.attachment && window !== undefined) {
							window.open(data?.attachment, '_blank')
						}
					}}
				>
					<div className={styles.fileUploadedItem}>
						<img src="/images/document.svg" alt="document" />
						<Typography variant="body">{data?.fileName || '--'}</Typography>
					</div>
					<img src="/images/task-detail-download.svg" alt="download" />
				</ButtonCustom>
			</div>
		</div>
	)
}
